import { Page } from '@app/components/page/Page';
import { SocialExportBreadcrumbs } from '@app/modules/social-export/components/breadcrumbs/SocialExportBreadcrumbs';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { ConnectionsManageView } from './ConnectionsManageView';

/**
 * Admin page to manage social-export connections for a single platform.
 * Platform is resolved from the `:platform` route param (stable component type — avoids remount on query-param changes).
 */
export function SocialExportManagePage() {
  const { platform: platformKey } = useParams<{ platform: string }>();
  const platform = socialPlatforms.get(platformKey)!;
  const { formatMessage } = useIntl();

  const title = formatMessage(
    {
      id: 'admin.socialExport.title',
      defaultMessage: 'Integración con {name}',
    },
    { name: platform.name },
  );

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={platform.Icon()} title={title} breadcrumbs={<SocialExportBreadcrumbs />} />
      <Page.Content>
        <ConnectionsManageView platform={platform} />
      </Page.Content>
    </Page>
  );
}
